import React from 'react'
import { Menu, MenuItem, Button, Container } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { ExpandMore } from '@mui/icons-material'
import NavigationGroupLink from './NavigationGroupLink'
import { NavigationGroup as NavigationGroupType } from '../../types/page'

interface Props {
  navGroup: NavigationGroupType
}

const NavigationGroupMenu: React.FC<Props> = ({ navGroup }) => {
  const { classes } = useStyles()

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <Container disableGutters key={navGroup.contentful_id}>
      <Button
        aria-controls="simple-menu"
        aria-haspopup="true"
        className={classes.button}
        disableRipple
        endIcon={<ExpandMore />}
        onClick={handleClick}
        variant="text"
      >
        {navGroup.title}
      </Button>
      <Menu
        anchorEl={anchorEl}
        classes={{ paper: classes.paper }}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {navGroup.links.map((link) => (
          <MenuItem
            className={classes.button}
            onClick={handleClose}
            key={link.contentful_id}
          >
            <NavigationGroupLink link={link} />
          </MenuItem>
        ))}
      </Menu>
    </Container>
  )
}

const useStyles = makeStyles()((theme) => ({
  button: {
    fontWeight: 'normal',
    fontSize: '.94rem',

    '&:focus': {
      outline: 0,
      border: 0,
    },

    '&:hover, &:active': {
      color: theme.palette.primary.main,
      backgroundColor: 'transparent',
    },

    '& > a': {
      color: theme.palette.text.primary,
    },
  },
  paper: {
    backgroundColor: theme.palette.background.default,
    borderRadius: '0',
    top: '4.6em !important',
  },
}))

export default NavigationGroupMenu
